import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import './App.css'
import TokenomicsList from './Tokenomics'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import Posts from './Posts'

// Fix Leaflet icon paths
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
})

const createNumberedIcon = (number) => {
  return L.divIcon({
    className: 'custom-number-icon',
    html: `<div class="marker-number">${number}</div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  })
}

function App() {
  const [markers, setMarkers] = useState([])

  useEffect(() => {
    L.Map.addInitHook('addHandler', 'tap', L.Tap)

    const loadMarkers = async () => {
      try {
        const response = await fetch('/markers.json')
        if (!response.ok) {
          throw new Error('Failed to load markers')
        }
        const data = await response.json()

        const normalized = data.map((marker) => ({
          ...marker,
          billboards: (marker.billboards || []).map((billboard) => ({
            ...billboard,
            xUrl: (billboard.xUrl || '').trim(),
          })),
        }))

        setMarkers(normalized)
      } catch (error) {
        console.error('Could not load markers.json:', error)
      }
    }

    loadMarkers()
  }, [])

  const total = markers.reduce((acc, curr) => {
    acc += curr.billboards.length
    return acc
  }, 0)

  return (
    <div className='map-container'>
      {/* 🔹 Banner Section */}
      <header className='header'>
        <div className='banner'>
          <h1 className='banner-title'>
            <img alt='logo' src='/logo.jpg' />
            $BILL
          </h1>
          <div className='socials'>
            <a
              href='https://x.com/i/communities/1975814532921503822'
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
            >
              <img src='x.webp' alt='X' />
            </a>
            <a
              href='https://dexscreener.com/solana/hnxrfm75oxqw2atwbvfymrfift1gudjegfproat5jkpq'
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
            >
              <img src='/dex.png' alt='X' />
            </a>

            <a
              href='https://pump.fun/coin/33LZGLLvtRDx3uAfJ1CcBSC7pNFqdiCBAvwPsVkBpump'
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
            >
              <img src='/pumpfun.png' alt='PumpFun' />
            </a>
          </div>
        </div>
        <p>
          We are placing billboards to promote brands and communities built on
          Solana.
        </p>
      </header>
      <MapContainer
        center={[44.393160604754925, 9.545674343870816]} // Center of the USA
        zoom={2}
        style={{ height: '80%', width: '100%' }}
      >
          <TileLayer
    url="https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png?key=cb1_2x88_1_d7dcab31dd3918f914357f97"
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
    subdomains={['a', 'b', 'c', 'd']}
    maxZoom={20}
  
    
  />
        {markers.map((marker, i) => (
          <Marker
            key={i}
            position={marker.position}
            icon={createNumberedIcon(marker.billboards.length)}
          >
            <Popup width={250}>
              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                modules={[Pagination]}
                width={250}
              >
                {marker.billboards.map((billboard) => (
                  <SwiperSlide title={marker.title}>
                    <a
                      href={billboard.xUrl}
                      target='_blank'
                      rel='noopener noreferrer'
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        color: '#6ab8ff',
                        margin: '16px 0',
                        textDecoration: 'underline',
                      }}
                    >
                      See on X
                    </a>
                    <p style={{ textAlign: 'center', color: 'white' }}>
                      {billboard.subtitle}
                    </p>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Popup>
          </Marker>
        ))}
        <div className='total-billboard-info'>
          Total {total} billboards placed.
        </div>
        <div className='billboard-wrapper'>
          <div className='billboard'>
            <div className='msg'>
              Would you like to be on a billboard?
              <p className='msg'>
                {' '}
                Contact{' '}
                <a
                  href='https://x.com/BillboardCTO'
                  className='contact_link'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  @BillboardCTO
                </a>{' '}
                on X.
              </p>
            </div>
          </div>
          <div className='pole'></div>
        </div>
      </MapContainer>      
      <TokenomicsList />
      <Posts posts={markers} total={total} />
      <footer className='footer'>
        <p>© {new Date().getFullYear()} BILLBOARD — Built with ❤️ on Solana</p>
        <p>Disclaimer: Figures subject to change. Always DYOR. </p>
      </footer>
    </div>
  )
}

export default App
